export function removePageViewNameIds(route: string) {
    // Replace GUIDs, number IDs
    const guidRegExp = /\/[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}/;
    const numberIdRegExp = /\/\d+/g;

    // Replace tenant IDs in routes appearing after module name
    const dataTenantIdRegExp = /\/data\/(?!tenant-selection)[\w]+/g;
    const platformTenantIdRegExp = /\/platform\/(?!tenant-selection)[\w]+/g;
    const homeTenantIdRegExp = /\/home\/(?!tenant-selection)[\w]+/g;

    return route
        .replace(dataTenantIdRegExp, '/data/#')
        .replace(platformTenantIdRegExp, '/platform/#')
        .replace(homeTenantIdRegExp, '/home/#')
        .replace(guidRegExp, '/#')
        .replace(numberIdRegExp, '/#');
}
